<template>
  <div class="photo-gallery" v-bind:class="type">
    <slot></slot>
  </div>
</template>

<script>
require("magnific-popup");

export default {
  props: {
    type: {
      default: "slider",
    },
  },

  data() {
    return {
      // images: []
    };
  },

  mounted() {
    console.log("Photo Gallery Component Mounted.");
    if (this.type === "justified") {
      $(this.$el)
        .justifiedGallery({
          captions: false,
          rowHeight: 180,
          // waitThumbnailsLoad: false,
          margins: 7,
          border: 0,
          rel: "gallery1",
        })
        .on("jg.complete", () => {
          this.initPopup();
        });
    } else {
      $(this.$el).on("init", () => {
        this.initPopup();
      });

      $(this.$el).slick({
        // normal options...
        centerMode: true,
        slidesToShow: 1,
        initialSlide: 0,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
        cssEase: "linear",
        variableWidth: true,
      });
    }
  },

  methods: {
    initPopup: function () {
      $(this.$el).magnificPopup({
        type: "image",
        delegate: "a",
        gallery: {
          enabled: true,
        },
        // callbacks: {
        //     elementParse: function (item) {
        //         console.log('asdasdasd', item.el);
        //         item.src = $(item.el).attr('src');
        //     }
        // }
      });
    },
  },
};
</script>
<style lang="scss">
.photo-gallery.slider {
  width: 100%;
}

.photo-gallery img {
  cursor: pointer;
}

.photo-gallery > div {
  width: 100%;
}

.photo-gallery {
  .slick-slide .image {
    padding: 10px;
  }

  .slick-slide img {
    border: 5px solid #fff;
    display: block;
    width: auto !important;
    max-height: 100%;
    height: 400px;
  }

  .slick-slide img.slick-loading {
    border: 0;
  }

  .slick-slide img {
    border-color: transparent !important;
  }

  .slick-slider {
    margin: 30px auto 50px;
  }

  .slick-slide a {
    outline: none;
  }

  .slick-arrow {
    z-index: 100;
    /*width: 30px;*/
    /*height: 30px;*/
  }

  .slick-arrow:before {
    color: #29363d !important;
    /*font-size: 30px;*/
  }

  /*.slick-prev {*/
  /*left: 5px;*/
  /*}*/
  /*.slick-next {*/
  /*right: 5px;*/
  /*}*/
}
</style>
